// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".c8a8aefbb2b5595a65ed5d8b867ff12c.js";
};